<template>
  <div class="myinfo">
    <TabBar :list="tab" v-model="tabinit" @selected="tabselected"/>
    <Loading :show="loading" class="loading">
      <router-view @loading="changeLoading"></router-view>
    </Loading>
  </div>
</template>

<script>
import TabBar from '@/components/layout/TabBar.vue'
import Loading from '@/components/base/Loading.vue'

export default {
  props: {
  },
  created () {
  },
  mounted () {
    console.log(this.$route.name)
    this.tabinit = this.getTab
  },
  data () {
    return {
      loading: true,
      tabinit: 0,
      tab: [
        {name: '프로필', index: 0, tab: 'profile'},
        {name: '계정', index: 1, tab: 'account'},
        {name: '비밀번호', index: 2, tab: 'password'},
        {name: '인증', index: 3, tab: 'proof'}
      ]
    }
  },
  name: 'Myinfo',
  watch: {
    $route () {
      this.tabinit = this.getTab
    }
  },
  computed: {
    getTab () {
      var item
      for (item in this.tab) {
        if (this.tab[item].tab === this.$route.name) {
          return this.tab[item].index
        }
      }
    }
  },
  methods: {
    tabselected (e) {
      if (e.prev !== e.current) {
        this.loading = true
        this.$router.push({name: e.param.tab})
      }
    },
    isTab (tab) {
      return tab === this.$route.params.tab
    },
    changeLoading (value) {
      console.log('tab loading', value)
      this.loading = value
    }
  },
  components: {
    TabBar,
    Loading
  }
}
</script>

<style scoped>
.myinfo {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px 50px 0px 50px;
}
.loading {
  flex: 1;
  /* display: flex; */
  /* width: 100%; */
  /* height: 100%; */
}
</style>



// WEBPACK FOOTER //
// src/router/page/myinfo/myinfo.vue